import { render } from "./CityChoice.vue?vue&type=template&id=6504c254&scoped=true"
import script from "./CityChoice.vue?vue&type=script&lang=js"
export * from "./CityChoice.vue?vue&type=script&lang=js"

import "./CityChoice.vue?vue&type=style&index=0&id=6504c254&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6504c254"]])

export default __exports__